
        
        function render() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"fill":"red","d":"M24 0l24 48H0z"}}),_c('path',{attrs:{"d":"M24.478 34.833c.525 0 .88-.027 1.064-.082.185-.054.277-.158.277-.311l.467-14.883c0-.218-.127-.366-.38-.442-.252-.077-.786-.115-1.603-.115h-.32c-.817 0-1.351.038-1.604.115-.253.076-.379.224-.379.442l.525 14.883c0 .153.087.257.262.311.175.055.535.082 1.079.082h.612zm.007 7.5c.722 0 1.321-.242 1.799-.727.477-.485.716-1.07.716-1.758 0-.707-.239-1.303-.716-1.787-.478-.485-1.077-.728-1.799-.728-.701 0-1.291.243-1.769.728-.477.484-.716 1.08-.716 1.787 0 .687.239 1.273.716 1.758.478.485 1.068.727 1.77.727z","fill":"#FFFCFC","fill-rule":"nonzero"}})])]);
        };
      

        module.exports = {
          
          render: render,
        };
      